'use strict';

angular.module('tcApp')
.directive('tcHtmlRichText', function($timeout, $ocLazyLoad, $rootScope,
										GlobalService, tcConstants, SystemRouter, $log) {
	return {
		require: ['^ngModel','?^tcComponent'],
		restrict: 'E',
		scope: {
			disabled: '@disabled',
			readOnly: '=ngReadonly',
			htmlrichtextname: '@tcHtmlrichtextName',
			componentForm: '=tcComponentForm'
		},
		link: function(scope, elm, attr, controllers) {
			var editor;
			var cannedTextStartPos = '';
			var cannedTextStartContainer = null;
			var enterPressed = false;
			var ngModel = controllers[0];
			var parentComponentHtmlName = controllers[1].componentHtmlName;
			var isDataLoaded = false;
			
			// Add this controller to FormController.
			ngModel.$name = scope.htmlrichtextname;
			scope.componentForm.$addControl(ngModel);
			
			// Get configuration from Global Service
			var lookupKeyCode = tcConstants.KEY_CODE.F6;
			if (angular.isDefined(GlobalService.configuration.lookup)) {
				lookupKeyCode = GlobalService.configuration.lookup.lookupKeyCode;
			}
			
			scope.$parent.$parent.insertCannedText = insertCannedText;
			scope.$parent.$parent.getCannedTextCode = getCannedTextCode;
			
			scope.$on('tcHtmlRichText:onAfterApply', function() {
				editor.fire('dataReady');
			});
			
			function getEditorDataForModel() {
				var newData = editor.getData();
				// ckeditor does not permit empty tags, so adds nbsp inside blank document
				if ((newData === String.fromCharCode(160)) || (newData === '&#160;')) {
					newData = '';
				}
				return newData;
			}
			
			function updateModel() {
				$timeout(function() {
					var newData = getEditorDataForModel();
					if (ngModel.$viewValue.value == newData) return;
					ngModel.$viewValue.value = newData;
					ngModel.$commitViewValue();
					// Only mark the field as dirty after the data has been loaded the first time
					if (isDataLoaded) {
						ngModel.$setDirty();
						ngModel.$modelValue.isDirty = true;
					}
				});
			}
			
			function setEditorDataOnLoad(editor, value) {
				editor.setData(value, {
					callback: function setDataLoaded() {
						isDataLoaded = true;
						if (scope.componentForm.$pristine) {
							ngModel.$setPristine();
						}
					}
				});
				if (attr.disabled) editor.setReadOnly(true);
			}

			$ocLazyLoad.load('../scripts/system/ckeditor/ckeditor.js').then(function editorOnLoad() {
				$timeout(function editorOnLoadTimeout() {
					// Timeout is required, otherwise 'src' value is undefined when this is executed
					editor = setupEditor();
					var value = ngModel.$modelValue.value;
					var src = ngModel.$modelValue.src;
					
					editor.on('instanceReady', function editorOnInstanceReady() {
						// For cached data, don't retrieve the document again
						if (angular.isDefined(value)) {
							setEditorDataOnLoad(editor, value);
						} else {
							SystemRouter.fetchDocumentData(src)
							.then(function onDocumentDataFetched(documentData) {
								setEditorDataOnLoad(editor, documentData.data);
							});
						}
					});
				});
			});
			
			function setupEditor() {
				var ck = CKEDITOR.replace(elm[0], {
					customConfig: 'htmlrichtext_config.js',
					language: ngModel.$modelValue.language,
					bodyId: 'CKEditorContent' + elm[0].id,
					tkLookupKey: lookupKeyCode,
					contentsCss: ['../scripts/system/ckeditor/htmlrichtext.css',
						'../custom/' + GlobalService.logonData.siteCode + '/scripts/websys.css'],
					disableNativeSpellChecker: !GlobalService.configuration.misc?.useBrowserSpellcheckerForHRT,
				});
							
				ck.on('key', function(e) {
					if (!e.editor.readOnly) {
						scope.$parent.$parent.handleKeyDown(e.data.domEvent.$);
				
						if (e.data.keyCode === tcConstants.KEY_CODE.BACK_SLASH) {
							var selection = e.editor.getSelection();
							var range = selection.getRanges()[0];
							cannedTextStartPos = range.endOffset;
							
							if (enterPressed && (cannedTextStartPos > 0)) {
								cannedTextStartPos = cannedTextStartPos - 1;
							}
							cannedTextStartContainer = range.endContainer;
						} else if (e.data.keyCode === tcConstants.KEY_CODE.ENTER) {
							cannedTextStartPos = '';
							cannedTextStartContainer = null;
						}
						
						// Check if enter key has been pressed previously.
						// To resolve CKEditor getting incorrect range after enter key is presses.
						// FOR CHROME ONLY!!! 
						enterPressed = (e.data.keyCode === tcConstants.KEY_CODE.ENTER);
					}
				});
			
				ck.on('change', updateModel);
				
				ck.on('contentDom', function(e) {
					e.editor.document.$.addEventListener('selectionchange', function() {
						if (!e.editor.readOnly) {
							var selectedText = e.editor.getSelection().getSelectedText();
							$rootScope.$broadcast('Component:setSelectedText', selectedText);
						}
					});
				});
				
				ck.on('dataReady', function() {
					$timeout(function() {
						var newData = getEditorDataForModel();
						ngModel.$viewValue.value = newData;
						ngModel.$commitViewValue();
					});
				});
				
				return ck;
			}
			
			function insertCannedText(desc, appendSpace, hasFormattedText, formattedTextID) {
				if (hasFormattedText) {
					// fetch the formatted canned text stream content
					SystemRouter.fetchDocumentData('epr.CannedText.cls?ID=' + formattedTextID)
									.then(function onDocumentDataFetched(documentData) {
								desc = '';
								if (angular.isString(documentData.data)) desc = documentData.data; 
								var selection = getCannedTextSelection();
								if (selection) {
									cannedTextStartPos = '';
								}
								// A trailing space is only appended when the code is used on HRT
								if (appendSpace) {
									desc += ' ';
								}

								editor.insertHtml(desc);
							}, function(error) {
								$log.error('Failed to fetch formatted canned text: ', error);
							});
				} else {
					var selection = getCannedTextSelection();
					if (selection) {
						cannedTextStartPos = '';
					}
					// A trailing space is only appended when the code is used on HRT
					if (appendSpace) {
						desc += ' ';
					}

					editor.insertText(desc);
				}
			}
			
			function getCannedTextCode() {
				var code = '';
				var bookmarks = editor.getSelection().createBookmarks2();
							
				var selection = getCannedTextSelection();
				if (selection) {
					code = selection.getSelectedText();
					selection.selectBookmarks(bookmarks);
					code = code.replace('\\', '');
					code = code.replace(/\u200B/g, ''); // remove zero width space.
					code = code.replace(/\s+$/, ''); // remove last space following a code.
				}
				return code;
			}
			
			function getCannedTextSelection() {
				var selection = '';
				if (cannedTextStartPos !== '') {
					selection = editor.getSelection();
					if (selection === null) return null;
					
					var range = selection.getRanges()[0];
					if (angular.isDefined(range)) {
						var endNode = range.endContainer;
						var endPos = range.endOffset;
						if (cannedTextStartContainer !== null) {
							// Strip out any zero width space characters when comparing
							var cannedTextContent = cannedTextStartContainer.getText().replace(/\u200B/g, '');
							if (cannedTextStartPos >= cannedTextContent.length) {
								// In case of an invalid selection, set the start to the end node
								// and manually try to find the backslash
								cannedTextStartContainer = endNode;
								cannedTextStartPos = endNode.getText().lastIndexOf('\\');
								if (cannedTextStartPos === -1) cannedTextStartPos = 0;
							}
						}
						range.setStart(cannedTextStartContainer, cannedTextStartPos);
						range.setEnd(endNode, endPos);
						selection.selectRanges([range]);
						
						if (selection.getSelectedText() === '') {
							// Where the selection is set incorrectly to a empty text node
							// Derive the range again from the start node of the document body element
							var innerNode = range.getBoundaryNodes()['startNode'];
							if (innerNode) {
								range.selectNodeContents(innerNode);
								range.startOffset = range.startContainer.getText().lastIndexOf('\\');
								if (range.startOffset < 0) range.startOffset = 0;
								selection.selectRanges([range]);
							}
						}
					}
				}
				return selection;
			}
						
			scope.$on('tcHtmlRichText:focus', function($event, componentHtmlName, itemName) {
				if ((parentComponentHtmlName === componentHtmlName) && (itemName === scope.htmlrichtextname)) {
					editor.focus();	
				}
			});
			
			scope.$on('$destroy', function() {
				if (angular.isDefined(editor)) {
					editor.destroy();
				}
			});
		}
	};
});
